import { withTheme } from 'styled-components'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import ProgramCard from './component.jsx'
import { connect } from 'react-redux'
import {
  getProgramPreferencesAndTraining,
  hasTeacherPreferences,
} from 'components/K8ProgramStatusRouter/helpers'

export const ProgramCardContainer = props => {
  const { currentSite, isK5Product, isMsProduct } = props || {}

  const { programPreferences } = getProgramPreferencesAndTraining(
    currentSite,
    isK5Product,
    isMsProduct,
  )

  const areTeachersPreferencesSet = hasTeacherPreferences(
    currentSite,
    isK5Product,
    isMsProduct,
  )

  return (
    <ProgramCard
      {...props}
      areTeachersPreferencesSet={areTeachersPreferencesSet}
      programPreferences={programPreferences}
    />
  )
}

const mapStateToProps = state => ({
  instructorData: state?.lmsManager?.instructorData,
})

export default withSiteContext(
  withTheme(connect(mapStateToProps, null)(ProgramCardContainer)),
)
